import { forwardRef, PropsWithChildren, ReactNode } from 'react';
import { Card } from '@mantine/core';

type UiCardProps = PropsWithChildren<{
  title?: ReactNode;
  onClick?: () => void;
}>;

export const UiCard = forwardRef<HTMLDivElement, UiCardProps>(
  ({ children, title, onClick }, ref) => (
    <Card
      p={16}
      ref={ref}
      shadow="xs"
      onClick={onClick}
      style={{ position: 'initial' }}
    >
      {title && (
        <Card.Section withBorder inheritPadding py={16} data-first="true">
          {title}
        </Card.Section>
      )}

      <Card.Section withBorder inheritPadding py={16}>
        {children}
      </Card.Section>
    </Card>
  )
);
